import dayjs from 'dayjs';
import { normalizeAndFormatBirthDateToString } from './dateFormatters';

/**
 * Checks if the provided date is within a specified number of months from the current date.
 *
 * @param {number} year - The year of the date.
 * @param {number} month - The month of the date (1-12).
 * @param {number} day - The day of the date.
 * @param {number} months - The number of months for the range to check against the current date.
 * @returns {boolean} True if the date is within the specified number of months from the current date, false otherwise.
 */
export function isDateWithinMonthsFromNow({
  year,
  month,
  day,
  months,
}: {
  year: number;
  month: number;
  day: number;
  months: number;
}): boolean {
  if ([year, month, day].some((value) => Number.isNaN(value))) {
    return false;
  }

  const dateString = normalizeAndFormatBirthDateToString({ year, month, day });
  const dateToCheck = dayjs(dateString, 'YYYY-MM-DD').startOf('day');
  const thresholdDate = dayjs().subtract(months, 'month').startOf('day');

  return (
    dateToCheck.isAfter(thresholdDate) || dateToCheck.isSame(thresholdDate)
  );
}
